import { FAGroupViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { mockFAGroupHelpers } from './helpers';

const { defaultValues, pensionParameters, generateValidToForExpiringGroup } = mockFAGroupHelpers;

const standard: FAGroupViewModel[] = [
  {
    faGroupId: '0000039884',
    fokId: 'FOK300815',
    fokText: 'FOK300815 Arbetare - Kollektivavtal Restaurang',
    validFrom: '2024-08-01',
    validTo: null,
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2024-08-01', validTo: null }],
    ...defaultValues,
  },
  {
    faGroupId: '0000039881',
    fokId: 'FOK0000374',
    fokText: 'FOK0000374 Arbetare - Kollektivavtal Hemserviceföretag',
    validFrom: '2022-10-01',
    validTo: '2023-03-01',
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2022-07-01', validTo: null }],
    ...defaultValues,
  },
  {
    faGroupId: '0000039882',
    fokId: 'FOK000847',
    fokText: 'FOK000847 Arbetare - Utgången FOK',
    validFrom: '2023-07-01',
    validTo: '2024-03-01',
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2023-07-01', validTo: '2024-03-01' }],
    ...defaultValues,
  },
  {
    faGroupId: '0000039883',
    fokId: 'FOK300812',
    fokText: 'FOK300812 Arbetare - Kollektivavtal Transportavtalet',
    validFrom: '2023-10-05',
    validTo: null,
    fokParameters: [],
    ...defaultValues,
  },
  {
    faGroupId: '0000039885',
    fokId: 'FOK567890',
    fokText: 'FOK567890 Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
    validFrom: '2024-01-01',
    ...defaultValues,
    isExpiring: true,
    validTo: generateValidToForExpiringGroup(),
    fokParameters: [
      { fokParameterInfos: pensionParameters, validFrom: '2018-10-01', validTo: generateValidToForExpiringGroup() },
    ],
  },
];

const multipleOptions: FAGroupViewModel[] = [
  {
    faGroupId: '0000039884',
    fokId: 'FOK1234',
    fokText: 'FOK1234 - Arbetare - Kollektivavtal Serviceentreprenad vid sjukhus, vårdinrättningar och skolor',
    validFrom: '2022-07-01',
    validTo: null,
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2022-07-01', validTo: null }],
    ...defaultValues,
  },
  {
    faGroupId: '0000039881',
    fokId: 'FOK234',
    fokText: 'FOK234 - Arbetare - Kollektivavtal Städpersonal',
    validFrom: '2023-01-01',
    validTo: null,
    fokParameters: [],
    ...defaultValues,
  },
  {
    faGroupId: '0000039882',
    fokId: 'FOK345',
    fokText: 'FOK345 - Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    validFrom: '2024-01-01',
    validTo: null,
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2024-01-01', validTo: null }],
    ...defaultValues,
  },
];

const oneOption: FAGroupViewModel[] = [
  {
    faGroupId: '0000039881',
    fokId: 'FOK123',
    fokText: 'Arbetare - Kollektivavtal Serviceentreprenad vid sjukhus, vårdinrättningar och skolor',
    validFrom: '2024-07-01',
    validTo: null,
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2022-07-01', validTo: null }],
    ...defaultValues,
  },
];

const withVaryingTimeSpans: FAGroupViewModel[] = [
  {
    faGroupId: '0000039884',
    fokId: 'FOK300815',
    fokText: 'FOK300815 - Arbetare - Kollektivavtal Restaurang',
    validFrom: '2024-08-01',
    validTo: null,
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2024-08-01', validTo: null }],
    ...defaultValues,
  },
  {
    faGroupId: '0000039881',
    fokId: 'FOK300881',
    fokText: 'FOK300881 - Arbetare Kollektivavtal Plåt- och Ventilationsavtalet',
    validFrom: '2018-11-16',
    validTo: null,
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2024-08-01', validTo: null }],
    ...defaultValues,
  },
  {
    faGroupId: '0000039882',
    fokId: 'FOK000374',
    fokText: 'FOK000374 - Arbetare - Kollektivavtal Hemserviceföretag',
    validFrom: '2022-10-01',
    validTo: '2024-07-01',
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2023-12-30', validTo: null }],
    ...defaultValues,
  },
  {
    faGroupId: '0000039883',
    fokId: 'FOK567890',
    fokText: 'FOK567890 - Arbetare kollektivavtal Lantbruk, djurpark, vattenbruk',
    validFrom: '2024-10-20',
    validTo: null,
    fokParameters: [{ fokParameterInfos: pensionParameters, validFrom: '2025-02-01', validTo: null }],
    ...defaultValues,
  },
];

const nonPensionParam: FAGroupViewModel[] = [
  {
    faGroupId: '0000039884',
    fokId: 'FOK12333',
    fokText: 'Arbetare - Kollektivavtal Serviceentreprenad vid sjukhus, vårdinrättningar och skolor',
    validFrom: '1999-01-01',
    validTo: null,
    fokParameters: [
      {
        fokParameterInfos: [
          ...pensionParameters,
          { parameterValue: 'arbete_utomlands', parameterDescription: 'Arbete utomlands' },
        ],
        validFrom: '1999-01-01',
        validTo: null,
      },
    ],
    ...defaultValues,
  },
  {
    faGroupId: '0000039881',
    fokId: 'FOK2345',
    fokText: 'Arbetare - Kollektivavtal Städpersonal',
    validFrom: '1999-01-01',
    validTo: null,
    fokParameters: [
      {
        fokParameterInfos: [
          pensionParameters[0],
          { parameterValue: 'arbete_utomlands', parameterDescription: 'Arbete utomlands' },
          { parameterValue: 'arbete_under_jord', parameterDescription: 'Arbete under jord' },
        ],
        validFrom: '1999-01-01',
        validTo: null,
      },
    ],
    ...defaultValues,
  },
];

const prodExample: FAGroupViewModel[] = [
  {
    // kab: {
    //   kabId: 'KAB800106',
    //   kabDescription: null,
    //   kabName: 'Afa-försäkringar, Omställningsförsäkring och Avtal',
    // },
    fokId: 'FOK301123',
    fokText: 'FOK301123 Arbetare, när kollektivavtal för arbetare saknas',
    validTo: null,
    faGroupId: '0000446922',
    validFrom: '2024-01-01',
    fokParameters: [
      {
        validFrom: '2024-01-01',
        validTo: null,
        fokParameterInfos: [
          {
            parameterValue: 'TILLVAL_ASL65+',
            parameterDescription: 'Avtalspension SAF-LO 65+',
          },
        ],
      },
    ],
    kabId: 'KAB800106',
    kabName: 'Afa-försäkringar, Omställningsförsäkring och Avtal',
    isExpiring: false,
  },
];

export const mockFAGroups = {
  standard,
  oneOption,
  withVaryingTimeSpans,
  multipleOptions,
  nonPensionParam,
  prodExample,
};
